(() => {
  const moneyFormatter = (currency) => new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency || 'BRL'
  });

  const getVariantId = (panel) => {
    const productInfo = panel.closest('product-info');
    if (!productInfo) return panel.dataset.currentVariantId;

    const addToCartInput = productInfo.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"], .product-variant-id'
    );

    return addToCartInput?.value || panel.dataset.currentVariantId;
  };

  const setupPanel = (panel) => {
    if (panel.dataset.mbReady === 'true') return;

    const variantsNode = panel.querySelector('[data-mb-variants]');
    if (!variantsNode) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    panel.dataset.mbReady = 'true';

    const productInfo = panel.closest('product-info');
    const offer = panel.querySelector('[data-mb-offer]');
    const discountNode = panel.querySelector('[data-mb-discount]');
    const savingNode = panel.querySelector('[data-mb-saving]');
    const pixNode = panel.querySelector('[data-mb-pix]');
    const installmentNode = panel.querySelector('[data-mb-installment]');
    const stock = panel.querySelector('[data-mb-stock]');
    const stockCount = panel.querySelector('[data-mb-stock-count]');
    const pixDiscount = Number(panel.dataset.pixDiscount || 0);
    const installments = Math.max(1, Number(panel.dataset.installments || 1));
    const lowStockThreshold = Math.max(1, Number(panel.dataset.lowStockThreshold || 12));
    const formatter = moneyFormatter(panel.dataset.currency);

    const formatMoney = (cents) => formatter.format(Number(cents || 0) / 100);

    const update = () => {
      const selectedId = String(getVariantId(panel));
      const variant = variants.find((item) => String(item.id) === selectedId) || variants[0];
      if (!variant) return;

      panel.dataset.currentVariantId = variant.id;

      const price = Number(variant.price || 0);
      const compareAt = Number(variant.compare_at_price || 0);
      const hasOffer = compareAt > price;

      if (offer) {
        offer.hidden = !hasOffer;
        if (hasOffer) {
          const saving = compareAt - price;
          const discount = Math.round((saving / compareAt) * 100);
          if (discountNode) discountNode.textContent = String(discount);
          if (savingNode) savingNode.textContent = formatMoney(saving);
        }
      }

      if (pixNode) {
        pixNode.textContent = formatMoney(price * ((100 - pixDiscount) / 100));
      }

      if (installmentNode) {
        installmentNode.textContent = formatMoney(price / installments);
      }

      if (stock) {
        const quantity = Number(variant.inventory_quantity || 0);
        const showLowStock =
          variant.inventory_management === 'shopify' &&
          variant.inventory_policy === 'deny' &&
          quantity > 0 &&
          quantity <= lowStockThreshold;

        stock.hidden = !showLowStock;
        if (showLowStock && stockCount) stockCount.textContent = String(quantity);
      }
    };

    update();

    productInfo?.addEventListener('change', () => window.setTimeout(update, 0));
    productInfo?.addEventListener('variant:change', update);

    const variantInput = productInfo?.querySelector('.product-variant-id');
    if (variantInput) {
      new MutationObserver(update).observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  };

  const setupAll = (root = document) => {
    root.querySelectorAll('[data-mb-product-conversion]').forEach(setupPanel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll());
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
